var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "JoinableAgent" } },
    [
      _c(
        "div",
        { staticClass: "search-input" },
        [
          _c("a-input-search", {
            attrs: { placeholder: _vm.$t("Search agent") },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.filteredAgents.length > 0
        ? [
            _c(
              "SupsisTable",
              _vm._b(
                { attrs: { columns: _vm.columns, rows: _vm.filteredAgents } },
                "SupsisTable",
                _vm.tableOptions,
                false
              )
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "no-agents-placeholder" },
              [
                _c("a-icon", { attrs: { type: "frown" } }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("No agents available to forward"))),
                ]),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }